import { useEffect } from 'react';
import { useUnmount } from 'react-use';

import { AppointmentId } from '@dreryk/egabinet-appointment-published-language-api';
import {
   VisitMedicalServiceSummary,
   VisitMedicalServiceSummaryQuery,
} from '@dreryk/egabinet-financial-settlement-frontend-api';
import { PurchaseId } from '@dreryk/egabinet-financial-settlement-published-language-api';

import { useCqrsSearch } from '@dreryk/command-query-react-common';
import { paginations } from '@dreryk/command-query-ws-client';
import { dispatchSnackbarNegativeEvent } from '@dreryk/react-components';

import { visitSettlementTranslationKeys } from '../../translations';

import { useMedicalServicesCounterGlobalState } from './useMedicalServicesCounterGlobalState';

type MedicalServicesCounterResolverProps = {
   appointmentIds: AppointmentId[];
};

export const MedicalServicesCounterResolver = (options: MedicalServicesCounterResolverProps): null => {
   const { updateState, resetCounter } = useMedicalServicesCounterGlobalState();

   const { data: medicalServicesSummary } = useCqrsSearch<VisitMedicalServiceSummary>(
      () => {
         const query = new VisitMedicalServiceSummaryQuery();
         query.purchaseIds = options.appointmentIds.map((appointmentId) => PurchaseId.forAppointment(appointmentId));
         return query;
      },
      paginations.all(),
      {
         onUnexpectedError: () =>
            dispatchSnackbarNegativeEvent(visitSettlementTranslationKeys.counterResolver.errors.unexpectedError),
      }
   );

   useEffect(() => {
      if (!medicalServicesSummary) {
         return;
      }

      updateState(
         medicalServicesSummary.map(({ purchaseId, medicalServiceCount }) => [purchaseId, medicalServiceCount])
      );
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [medicalServicesSummary]);

   useUnmount(resetCounter);

   return null;
};
